import { render } from "./ProspettoConsumi.vue?vue&type=template&id=543c0252&scoped=true"
import script from "./ProspettoConsumi.vue?vue&type=script&lang=js"
export * from "./ProspettoConsumi.vue?vue&type=script&lang=js"

import "./ProspettoConsumi.vue?vue&type=style&index=0&id=543c0252&lang=css"
import "./ProspettoConsumi.vue?vue&type=style&index=1&id=543c0252&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543c0252"]])

export default __exports__